import ErrorPage from '@components/common/ErrorPage';
import Loading from '@components/common/Loading';
import Notifier from '@components/common/Notifier';
import React, {Suspense, lazy} from 'react';
import routePath, {Routes} from '@account/utils/route';
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  useParams,
} from 'react-router-dom';
import {getError} from '@account/utils/errors';
import {useOrg} from '@hooks/data/organizations/useOrg';

const PlansPage = lazy(() => import('@account/components/plans/PlansPage'));
const PlanDetailPage = lazy(
  () => import('@account/components/plans/PlanDetailPage')
);
const OrgUsersPage = lazy(() => import('./OrgUsersPage'));
const OrgGeneralPage = lazy(() => import('./OrgGeneralPage'));
const OrgsPage = lazy(() => import('./OrgsPage'));
const OrgEntitlementsPage = lazy(
  () => import('./entitlements/OrgEntitlementsPage')
);
const TaskingContractDetailPage = lazy(
  () => import('@components/tasking/TaskingContractDetailPage')
);

const Organization = () => {
  const {orgId} = useParams();
  const {pathname} = useLocation();

  const {data, error, isLoading} = useOrg(orgId);

  if (error) {
    return <ErrorPage {...getError(error)} />;
  }

  if (isLoading) {
    return <Notifier progress open message="Loading Organization..." />;
  }

  return (
    <>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />

          <Route path={Routes.ORG_GENERAL}>
            <OrgGeneralPage organization={data} />
          </Route>

          <Route path={Routes.ORG_PLAN_TASKING} exact>
            <Redirect to={routePath(Routes.ORG_PLANS, {orgId})} />
          </Route>

          <Route path={Routes.ORG_PLAN_TASKING_DETAIL}>
            <TaskingContractDetailPage />
          </Route>

          <Route path={Routes.ORG_PLAN_DETAIL} exact>
            <PlanDetailPage />
          </Route>

          <Route path={Routes.ORG_PLANS}>
            <PlansPage organization={data} />
          </Route>

          <Route path={Routes.ORG_ENTITLEMENTS}>
            <OrgEntitlementsPage organization={data} />
          </Route>

          <Route path={Routes.ORG_SUBORGS}>
            <OrgsPage organization={data} />
          </Route>

          <Route path={Routes.ORG_USERS}>
            <OrgUsersPage organization={data} />
          </Route>

          <Route path={Routes.ORG_DETAIL}>
            <Redirect to={routePath(Routes.ORG_GENERAL, {orgId})} />
          </Route>

          <Redirect to={Routes.ROOT} />
        </Switch>
      </Suspense>
    </>
  );
};

export default Organization;
